<template>
  <div class="h-100">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading">
          <div class="d-flex justify-content-start align-items-center mb-3">
            <b-btn
              v-if="$root.user.isAdmin"
              class="text-uppercase"
              size="sm"
              variant="primary"
              @click="add"
            >
              <b-icon class="mr-1" icon="plus" scale="1.5x" />
              Pridať
            </b-btn>
          </div>
          <div v-if="!data.length" class="nodata-container">
            <div class="text-center my-3">
              <div class="mb-3">
                <b-icon font-scale="5" icon="question-diamond" />
              </div>
              <h2 class="mb-3">Žiadne dáta</h2>
            </div>
          </div>
          <template v-else>
            <power-view :data="data" :energetic="energetic" />
          </template>
        </div>
      </transition>
    </b-overlay>
    <add-time ref="timeForm" />
  </div>
</template>
<script>
import AddTime from './Add'
import PowerView from './View'
import { mapState } from 'vuex'

export default {
  components: {
    AddTime,
    PowerView,
  },
  data() {
    return {
      loading: false,
      data: [],
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.$root.$on('reloadEnergeticTimeData', this.fetchData)
  },
  beforeDestroy() {
    this.$root.$off('reloadEnergeticTimeData')
  },
  methods: {
    add({ edit = false }) {
      this.$refs.timeForm.edit = edit
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-time')
      })
    },
    remove(id) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť tieto časy?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api.post(`energetics/${id}/remove_time`).then((res) => {
            this.$swal({
              type: 'success',
              position: 'top',
              showCloseButton: true,
              text: res.data.message,
              timer: 5000,
            })
            this.fetchData()
          })
        }
      })
    },
    fetchData(silent = false) {
      this.loading = !silent
      this.$api
        .get(`energetics/${this.$route.params.energetics_id}/time/get_list`)
        .then((res) => {
          this.data = res.data.data
          if (!silent) {
            this.loading = false
          }
        })
    },
  },
}
</script>
